import { FunctionComponent } from 'react';
import classnames from 'classnames';

// components
import ImgLazy from '@Components/Utils/Lazy/Image';

// Contexts
import { ViewMedia } from '@Components/Utils/ViewDetected';
import { withCategoryStore, CategoryItem } from '@Components/Categories/Context';

// styles
import styles from './Post.module.scss';

interface PostProps {
    title?: string;
    className?: string;
    imageWidth?: number;
    fullBanner?: boolean;
    description?: string;
    isShowBadge?: boolean;
    infoClassName?: string;
    badgePosition?: boolean;
    category?: CategoryItem;
    imageClassName?: string;
    badgeClassName?: string;
    titleClassName?: string;
    isShowDescription?: boolean;
    imageWrapperClassName?: string;
    image?: { [key: string]: any };
    imagePosition?: 'left' | 'top' | 'right';
}

const Post: FunctionComponent<PostProps> = ({
    image,
    title,
    category,
    className,
    fullBanner,
    imageWidth,
    description,
    isShowBadge,
    imagePosition,
    infoClassName,
    badgePosition,
    imageClassName,
    titleClassName,
    badgeClassName,
    isShowDescription,
    imageWrapperClassName,
}) => {
    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.full_banner]: fullBanner,
            [styles.image_left]: imagePosition === 'left',
            [styles.image_right]: imagePosition === 'right',
        },
        className,
    ]);

    const infoClass = classnames([styles.info, infoClassName]);
    const imageClass = classnames([styles.image, imageClassName]);
    const badgeClass = classnames([styles.badge, badgeClassName]);
    const titleClass = classnames([styles.title, titleClassName]);
    const imageWrapperClass = classnames([styles.image_wrapper, imageWrapperClassName]);

    return (
        <div className={wrapperClassName}>
            <div className={imageWrapperClass}>
                <ImgLazy
                    width={360}
                    height={200}
                    className={imageClass}
                    key={`post_image_${title}`}
                    alt={image?.alternativeText || title}
                    src={`${image?.url}${imageWidth ? `?width=${imageWidth}` : ''}`}
                />

                {isShowBadge && badgePosition && (
                    <ViewMedia is="desktop">
                        <span className={badgeClass} style={{ background: category.color }}>
                            {category.title}
                        </span>
                    </ViewMedia>
                )}
            </div>

            <div className={infoClass}>
                {isShowBadge && !badgePosition && (
                    <span className={badgeClass} style={{ [!fullBanner ? 'color' : 'background']: category.color }}>
                        {category.title}
                    </span>
                )}

                <span className={titleClass}>{title}</span>

                {isShowDescription && (
                    <ViewMedia is="desktop">
                        <span
                            className={styles.description}
                            dangerouslySetInnerHTML={{
                                __html: description,
                            }}
                        />
                    </ViewMedia>
                )}
            </div>
        </div>
    );
};

Post.defaultProps = {
    image: {},
    title: '',
    className: '',
    description: '',
    isShowBadge: false,
    infoClassName: '',
    imageClassName: '',
    imagePosition: 'top',
    badgePosition: false,
    isShowDescription: false,
    imageWrapperClassName: '',
    category: {
        id: '',
        slug: '',
        title: '',
        color: '',
    },
};

export default withCategoryStore(Post);
